var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewestActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.83,33.35c-.4-1.2-1.44-2.07-2.69-2.26l-14.55-2.22-6.53-13.92c-.56-1.19-1.75-1.94-3.06-1.94s-2.5.76-3.06,1.94l-6.53,13.92-14.55,2.22c-1.25.19-2.29,1.06-2.69,2.26s-.1,2.52.79,3.43l10.62,10.89-2.52,15.41c-.21,1.28.33,2.56,1.39,3.3,1.05.75,2.45.82,3.58.2l12.97-7.17,12.97,7.17c.51.28,1.07.42,1.64.42.68,0,1.36-.21,1.94-.62,1.06-.74,1.6-2.03,1.39-3.3l-2.52-15.41,10.62-10.89c.88-.91,1.19-2.23.78-3.43h.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewestActive);
export default __webpack_public_path__ + "static/media/Newest-active.1ea639c4c222e58ff97c62d3441ae49d.svg";
export { ForwardRef as ReactComponent };